export default function SiteHeader() {
  return (
    <header className="w-full flex items-end justify-start h-[220px] px-6 pb-10 shrink-0 lg:items-center lg:pb-0 lg:h-auto lg:pt-8">
      <a href="/" className="cursor-pointer">
        <img
          src="https://storage.readdy-site.link/project_files/7132ca6f-5f51-4f09-ac5f-77e8f75938d4/39302b61-2181-4ec9-8d03-edfa08f3da49_Logo-ECOS4.3D-6.png?v=9954720132db01543c2273faeaa0dd90"
          alt="Logo"
          className="h-[48px] md:h-[51px] w-auto object-contain"
        />
      </a>
    </header>
  );
}
